export default "__VITE_ASSET__67429c21__"